// blockUI behaviour — a CSS-only "blocked while async" overlay on a host element.
//
// The overlay is created lazily on the first block() and torn down on
// release()/destroy(), mirroring the bootstrap5 tier's adapter.
const blockUI = {
    create: function (el) {
        let overlay = null;

        const mount = function () {
            if (overlay !== null) {
                return;
            }
            // Mark the host so the CSS pins position:relative without
            // clobbering any existing inline style.
            el.classList.add('zit-cs-blockui-host');
            overlay = document.createElement('div');
            overlay.className = 'zit-cs-blockui-overlay';
            // Static markup only (no inline handlers) — CSP-safe.
            overlay.innerHTML = '<span class="zit-cs-spinner"></span>';
            el.appendChild(overlay);
        };

        const unmount = function () {
            if (overlay === null) {
                return;
            }
            overlay.remove();
            el.classList.remove('zit-cs-blockui-host');
            overlay = null;
        };

        return {
            block: function () { mount(); },
            release: function () { unmount(); },
            destroy: function () { unmount(); }
        };
    }
};

export default blockUI;
